import type { Node, Placement } from "../../api/types";
import { Button } from "../../components/Button";
import { Modal } from "../../components/Modal";
import "../../components/Form.css";

interface DeletePlacementDialogProps {
  placement: Placement | null;
  node: Node | undefined;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeletePlacementDialog({ placement, node, isDeleting, onCancel, onConfirm }: DeletePlacementDialogProps) {
  return (
    <Modal open={placement !== null} title="Stop running here" onClose={onCancel}>
      <p>
        Stop running this service on <strong>{node?.name ?? "this machine"}</strong>? The container is torn down
        there. To move it to a different machine, add it there afterward.
      </p>
      <div className="form-actions">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isDeleting}>
          Cancel
        </Button>
        <Button type="button" variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? "Removing…" : "Remove"}
        </Button>
      </div>
    </Modal>
  );
}
